import { render, staticRenderFns } from "./AgendamentoGrid.vue?vue&type=template&id=68bea4dd"
import script from "./AgendamentoGrid.vue?vue&type=script&lang=js"
export * from "./AgendamentoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports